import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from "./URLCatalog";
import { Alert, AlertDashboardItem, AlertDetail, AlertTableRow, Subscription } from "@models/Alertas";


export class AlertsService {
    private httpClient: HTTPClientInterface;

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient;
    }

    async getAlertsForOrganization(orgID: string): Promise<Alert[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.getForOrg, { organization_id: orgID });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async getAlertsForOrganizationDay(orgID: string, day: string): Promise<AlertDashboardItem[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.getForOrgDay, {
            organization_id: orgID,
            day
        });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async getAlertsTableForOrganizationDay(orgID: string, day: string): Promise<AlertTableRow[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.getForOrgDayTable, {
            organization_id: orgID,
            day
        });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async getAlertDetail(orgID: string, alertID: string): Promise<AlertDetail> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.getDetail, {
            organization_id: orgID,
            alert_id: alertID
        });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async getOrgLevelSubscriptions(orgID: string): Promise<Subscription[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.getOrgSubscriptions, { organization_id: orgID });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async addOrgLevelSubscription(orgID: string, targetID: string, targetType: string): Promise<void> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.postAddOrgSubscription, { organization_id: orgID });
        request.method = "POST";
        request.body = {
            targetID,
            targetType
        };

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async removeOrgLevelSubscription(orgID: string, subscriptionID: string): Promise<void> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.deleteRemoveOrgSubscription, { organization_id: orgID });
        request.method = "DELETE";
        request.body = {
            subscriptionID
        };

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async getBuildingLevelSubscriptions(orgID: string, buildingID: string): Promise<Subscription[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.getBuildingSubscriptions, {
            organization_id: orgID,
            building_id: buildingID
        });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async addBuildingLevelSubscription(orgID: string, buildingID: string, targetID: string, targetType: string): Promise<void> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.postAddBuildingSubscription, {
            organization_id: orgID,
            building_id: buildingID
        });
        request.method = "POST";
        request.body = {
            targetID,
            targetType
        };

        const response = await this.httpClient.execute(request);
        return response.result;
    }

    async removeBuildingLevelSubscription(orgID: string, buildingID: string, subscriptionID: string): Promise<void> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.Alerts.deleteRemoveBuildingSubscription, {
            organization_id: orgID,
            building_id: buildingID
        });
        request.method = "DELETE";
        request.body = {
            subscriptionID
        };
        const response = await this.httpClient.execute(request);
        return response.result;
    }
}
